import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Zone from '@wix/da-gruser-shared/pkg/components/Zone';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import GruserContext from '@wix/da-gruser-shared/pkg/context/GruserContext';
import { getExhibitionistStripWidgetConfig } from '../../../widgets/Exhibitionist/widgetConfig';
import { getGruserForDeviation, getGruserOwnerForDeviation } from '../../../DeviationPage/redux/helpers';
const GruserZoneLocal = ({ deviation })=>{
    var _deviation_author;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            creatorid: (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.useridUuid
        }
    }, /*#__PURE__*/ React.createElement(GruserContext.Provider, {
        value: {
            gruser: getGruserForDeviation(deviation),
            gruserOwner: getGruserOwnerForDeviation(deviation)
        }
    }, /*#__PURE__*/ React.createElement(Zone, {
        name: "local",
        withStaticAddWidget: true,
        mapModuleTypeToWidgetConfig: {
            exhibitionist: getExhibitionistStripWidgetConfig({
                t,
                dispatch
            })
        }
    })));
};
GruserZoneLocal.displayName = 'GruserZoneLocal';
export default GruserZoneLocal;
